import { GamoraFoundationError } from '../foundation/error/error.js';

/**
 * Not implemented
 * @type Error
 */
export class GamoraErrorNotImplemented extends GamoraFoundationError {
  constructor(message?: string) {
    super(message);
  }
}
